// Billing — CONSOLE-APP business, deliberately not an SDK module.
//
// Payment is root-app code (docs/BILLING.md): the console sells custom domains
// via its own `billing-checkout` function + Stripe webhook, exactly the way
// any app on s3p would sell anything (the platform primitive underneath is
// just `FnDef.http` + server functions). This file is the ONE typed client
// for those functions, so the wire shapes aren't re-encoded per page.

import type { PlatformClient } from "@s3p/sdk";

/** The features the console sells today. */
export type BillableFeature = "custom-domains";

export interface CheckoutInput {
	/** The project the purchase is FOR. */
	slug: string;
	feature: BillableFeature;
	/** Where Stripe sends the buyer back (`?checkout=success|cancelled`). */
	returnUrl: string;
}

export type CheckoutResult =
	/** Redirect the buyer to `url` — the Stripe-hosted Checkout session. */
	| { ok: true; url: string }
	/** No session was created. `billing-disabled` is the "wired but not
	 *  charging yet" master switch (secrets/stripe `enabled:false`). */
	| { ok: false; reason: "billing-disabled" | "already-entitled"; message?: string };

/** Ask the console's `billing-checkout` function for a Stripe-hosted Checkout
 *  session. Owner-gated server-side; the entitlement itself is granted only
 *  by the Stripe webhook (or `s3p-admin entitle`). */
export async function startCheckout(
	client: PlatformClient,
	input: CheckoutInput,
): Promise<CheckoutResult> {
	return (await client.fn("billing-checkout")(input)) as CheckoutResult;
}
